import { render, staticRenderFns } from "./ServiceSummary.vue?vue&type=template&id=d879ad6c&scoped=true"
import script from "./ServiceSummary.vue?vue&type=script&lang=js"
export * from "./ServiceSummary.vue?vue&type=script&lang=js"
import style0 from "./ServiceSummary.vue?vue&type=style&index=0&id=d879ad6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d879ad6c",
  null
  
)

export default component.exports